import Vue from 'vue';

// 格式化时间
function formatOnlyTime(time) {
    if (!time) return '-';
    const dateTime = new Date(typeof time == "string" ? time.replace(/-/g, "/"):time);
    const hh =
        dateTime.getHours() < 10 ?
            '0' + dateTime.getHours() :
            dateTime.getHours();
    const mm =
        dateTime.getMinutes() < 10 ?
            '0' + dateTime.getMinutes() :
            dateTime.getMinutes();
    const ss =
        dateTime.getSeconds() < 10 ?
            '0' + dateTime.getSeconds() :
            dateTime.getSeconds();
    return `${hh}:${mm}:${ss}`;
}
Vue.filter('formatOnlyTime', formatOnlyTime);

// 格式化日期时间
function formatTime(time) {
    if (!time) return '-';
    const dateTime = new Date(typeof time == "string" ? time.replace(/-/g, "/") : time);//将'-'换成'/',在没传时分秒时使时分秒输出为00:00:00
    const YY = dateTime.getFullYear();
    const MM =
        dateTime.getMonth() + 1 < 10 ?
            '0' + (dateTime.getMonth() + 1) :
            dateTime.getMonth() + 1;
    const DD =
        dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
    const hh =
        dateTime.getHours() < 10 ?
            '0' + dateTime.getHours() :
            dateTime.getHours();
    const mm =
        dateTime.getMinutes() < 10 ?
            '0' + dateTime.getMinutes() :
            dateTime.getMinutes();
    const ss =
        dateTime.getSeconds() < 10 ?
            '0' + dateTime.getSeconds() :
            dateTime.getSeconds();
    return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
}
Vue.filter('formatTime', formatTime);

function formatDateMinutes(time) {
    if (!time) return '-';
    const dateTime = new Date(typeof time == "string" ? time.replace(/-/g, "/") : time);
    const YY = dateTime.getFullYear();
    const MM =
        dateTime.getMonth() + 1 < 10 ?
            '0' + (dateTime.getMonth() + 1) :
            dateTime.getMonth() + 1;
    const DD =
        dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
    const hh =
        dateTime.getHours() < 10 ?
            '0' + dateTime.getHours() :
            dateTime.getHours();
    const mm =
        dateTime.getMinutes() < 10 ?
            '0' + dateTime.getMinutes() :
            dateTime.getMinutes();
    return `${YY}-${MM}-${DD} ${hh}:${mm}`;
}
Vue.filter('formatDateMinutes', formatDateMinutes);

function formatDate(time) {
    if (!time) return '-';
    const dateTime = new Date(typeof time == "string" ? time.replace(/-/g, "/"):time);
    const YY = dateTime.getFullYear();
    const MM =
        dateTime.getMonth() + 1 < 10 ?
            '0' + (dateTime.getMonth() + 1) :
            dateTime.getMonth() + 1;
    const DD =
        dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
    return `${YY}-${MM}-${DD}`;
}
Vue.filter('formatDate', formatDate);

function formatMonth(time) {
    if (!time) return '-';
    const dateTime = new Date(typeof time == "string" ? time.replace(/-/g, "/"):time);
    const YY = dateTime.getFullYear();
    const MM =
        dateTime.getMonth() + 1 < 10 ?
            '0' + (dateTime.getMonth() + 1) :
            dateTime.getMonth() + 1;
    return `${YY}-${MM}`;
}
Vue.filter('formatMonth', formatMonth);

function formatDateForCode(time) {
    const dateTime = time ? new Date(typeof time == "string" ? time.replace(/-/g, "/"):time) : new Date();
    const YY = dateTime.getFullYear();
    const MM =
        dateTime.getMonth() + 1 < 10 ?
            '0' + (dateTime.getMonth() + 1) :
            dateTime.getMonth() + 1;
    const DD =
        dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
    return `${YY}${MM}${DD}`;
}
Vue.filter('formatDateForCode', formatDateForCode);

function diffDate(time) {
    if (!time) return '-';
    return Math.floor(Math.abs(new Date(typeof time == "string" ? time.replace(/-/g, "/"):time) - new Date()) / (24 * 60 * 60 * 1000));
}
Vue.filter('diffDate', diffDate);

function remainDays(time) {
    if (!time) return '-';
    return Math.floor((new Date(typeof time == "string" ? time.replace(/-/g, "/"):time) - new Date()) / (24 * 60 * 60 * 1000));
}
Vue.filter('remainDays', remainDays);

function addDays(date, days) {
    if (!date) date = new Date();
    date.setDate(date.getDate() + days);
    return date;
}
Vue.filter('addDays', addDays);

function addTime(date, time) {
    if (!date) date = new Date();
    date.setTime(date.getTime() + time);
    return date;
}
Vue.filter('addTime', addTime);

function readableTime(time) {
    if (!time) return '-';
    var date = new Date(typeof time == "string" ? time.replace(/-/g, "/"):time);
    var difftime = Math.abs(new Date() - date)
    var pastFlg = new Date() > date
    // 获取当前时间的年月
    var nowyear = date.getFullYear();
    var nowmonth = date.getMonth + 1;
    var yearAllday = 0;
    var monthAllday = 0;
    // 判断是否为闰年
    if ((nowyear % 4 === 0 && nowyear % 100 !== 0) || nowyear % 400 === 0) {
        yearAllday = 366
    } else {
        yearAllday = 365
    }
    // 每个月的天数
    if (yearAllday === 366 && nowmonth === 2) {
        monthAllday = 29
    } else if (yearAllday === 365 && nowmonth === 2) {
        monthAllday = 28
    }
    if (nowmonth === 4 || nowmonth === 6 || nowmonth === 9 || nowmonth === 11) {
        monthAllday = 30
    } else {
        monthAllday = 31
    }
    if (pastFlg) {
        if (difftime > yearAllday * 24 * 3600 * 1000) {
            // //注释("超过一年");
            return Math.floor(difftime / (yearAllday * 24 * 3600 * 1000)) + "年前"
        } else if (difftime > monthAllday * 24 * 3600 * 1000 && difftime < yearAllday * 24 * 3600 * 1000) {
            // //注释("一年之内");
            return Math.floor(difftime / (monthAllday * 24 * 60 * 60 * 1000)) + "个月前";
        } else if (difftime > 7 * 24 * 60 * 60 * 1000 && difftime && difftime < monthAllday * 24 * 60 * 60 * 1000) {
            // //注释("一月之内");
            return Math.floor(difftime / (7 * 24 * 3600 * 1000)) + "周前";
        } else if (difftime < 7 * 24 * 3600 * 1000 && difftime > 24 * 3600 * 1000) {
            // //注释("一周之内");
            return Math.floor(difftime / (24 * 60 * 60 * 1000)) + "天前";
        } else if (difftime < 24 * 3600 * 1000 && difftime > 3600 * 1000) {
            // //注释("一天之内");
            return Math.floor(difftime / (60 * 60 * 1000)) + "小时前";
        } else if (difftime < 3600 * 1000 && difftime > 0) {
            // //注释("一小时之内");
            return Math.floor(difftime / (60 * 1000)) + "分钟前";
        }
    } else {
        if (difftime > yearAllday * 24 * 3600 * 1000) {
            // //注释("超过一年");
            return Math.ceil(difftime / (yearAllday * 24 * 3600 * 1000)) + "年内"
        } else if (difftime > monthAllday * 24 * 3600 * 1000 && difftime < yearAllday * 24 * 3600 * 1000) {
            // //注释("一年之内");
            return Math.ceil(difftime / (monthAllday * 24 * 60 * 60 * 1000)) + "个月内";
        } else if (difftime > 7 * 24 * 60 * 60 * 1000 && difftime && difftime < monthAllday * 24 * 60 * 60 * 1000) {
            // //注释("一月之内");
            return Math.ceil(difftime / (7 * 24 * 3600 * 1000)) + "周内";
        } else if (difftime < 7 * 24 * 3600 * 1000 && difftime > 24 * 3600 * 1000) {
            // //注释("一周之内");
            return Math.ceil(difftime / (24 * 60 * 60 * 1000)) + "天内";
        } else if (difftime < 24 * 3600 * 1000 && difftime > 3600 * 1000) {
            // //注释("一天之内");
            return Math.ceil(difftime / (60 * 60 * 1000)) + "小时内";
        } else if (difftime < 3600 * 1000 && difftime > 0) {
            // //注释("一小时之内");
            return Math.ceil(difftime / (60 * 1000)) + "分钟内";
        }
    }
}
Vue.filter('readableTime', readableTime);

function formatMinutes(time) {
    if (!time) return '-';
    return time;
}
Vue.filter('formatMinutes', formatMinutes);

export default {
    formatOnlyTime,
    formatTime,
    formatDate,
    formatMonth,
    formatDateForCode,
    diffDate,
    remainDays,
    addDays,
    addTime,
    readableTime,
    formatDateMinutes,
    formatMinutes,
}